<template>
  <v-container class="pa-0">
    <ArticlesInfiniteList
      :articles-list="articlesList"
      :error-loading-data="errorLoadingData"
      @addArticlesToBottom="addArticlesToBottomHandler"
      @addArticlesToTop="addArticlesToTopHandler"
      @currentArticleChange="currentArticleChangeHandler"
    ></ArticlesInfiniteList>
  </v-container>
</template>

<script>
//import APIService from '@/apiservices/APIService.js'
import ArticlesInfiniteList from '@/components/ArticlesInfiniteList.vue'
import { articlesInfinitListMixin } from '@/components/mixins/articlesInfinitList'

export default {
  components: {
    ArticlesInfiniteList
  },
  mixins: [articlesInfinitListMixin],
  data() {
    return {}
  },
  created() {
    this.filterOptions = { order_by: '-media_pub_date' }
  },
  methods: {}
}
</script>

<style></style>
